export default [{ value: 1, label: 'Void' },
{ value: 2, label: 'Deleted' },
{ value: 3, label: 'Draft' },
{ value: 4, label: 'Sent' },
{ value: 5, label: 'Viewed' },
{ value: 6, label: 'Paid' },
{ value: 7, label: 'Attempted' },
{ value: 8, label: 'Refunded'}]